const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/orders`,
    customers: `${API_URL}/customers`,
    turnarounds: `${API_URL}/turnarounds`,
    information: `${API_URL}/order/information`,
    estimate: `${API_URL}/order/estimate`,
    estimates: `${API_URL}/estimates`,
    exportPdf: `${API_URL}/order/export-pdf`,
    uploadFiles: `${API_URL}/order/upload-files`,
    progress: `${API_URL}/order/progress`,
    downloadFile: `${API_URL}/order/download-file`,
    deleteFile: `${API_URL}/order/delete-file`,
    sendToProduction: `${API_URL}/order/send-to-production`,
    calculateShipping: `${API_URL}/order/calculate-shipping`,
    intersectPaperCategories: `${API_URL}/paper-category/intersect`,
    intersectPaperWeights: `${API_URL}/paper/intersect-weights`,
    intersectPapers: `${API_URL}/paper/intersect-papers`,
    changeStatus: `${API_URL}/estimate/change-status`,
    changeHaveArtworks: `${API_URL}/estimate/change-have-artworks`
};

export default apiUrls;
